import { isServerNotRespondingError } from '@/infrastructure/errors'
import { useAppErrors } from '@/composables/app/useAppErrors'

export function useGlobalServerErrorToast() {
  const { t } = useI18n()
  const { getErrors, clearErrors } = useAppErrors()

  const isVisible = ref(false)

  const serverNotRespondingError = computed(() => {
    for (let i = getErrors.value.length - 1; i >= 0; i -= 1) {
      const candidate = getErrors.value[i]
      if (candidate?.type === 'api' && isServerNotRespondingError(candidate)) {
        return candidate
      }
    }

    return null
  })

  const message = computed(() => {
    if (!serverNotRespondingError.value) return ''
    return t('common.serverNotResponding')
  })

  watch(serverNotRespondingError, (error) => {
    isVisible.value = !!error
  }, { immediate: true })

  function onClose() {
    clearErrors()
  }

  return {
    isVisible,
    message,
    onClose,
  }
}
